// src/hooks/useAuth.ts
import { useAuthStore } from '../store/auth';
import type { User } from '../types/auth';

export function useAuth() {
  // Destructure les propriétés et actions du store Zustand, y compris _hasHydrated
  const { token, user, login, logout, _hasHydrated } = useAuthStore();

  const isAuthenticated = Boolean(token && user);

  const loginUser = (token: string, user: User) => {
    login(token, user);
  };

  return {
    token,
    user,
    isAuthenticated,
    login: loginUser,
    logout,
    hasHydrated: _hasHydrated, // Expose l'état d'hydratation
  } as const;
}